import React from 'react';
import ProfessionalLogin from './Login';

// Re-export the refactored component with the same name as before
const Config = () => {
  return <ProfessionalLogin />;
};

export default Config;